<div class="container-fluid glb-popup">
  <h2>{{ formTitle }}</h2>
  <p-toast [style]="{ marginTop: '80px' }"></p-toast>
  <p-confirmDialog
    header="Confirmation"
  icon="pi pi-exclamation-triangle"></p-confirmDialog>

  @if (formLoading) {
    <div>
      <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
    </div>
  }


  <button
    mat-icon-button
    [mat-dialog-close]="true"
    style="float: right; top: -50px; background-color: transparent">
    <i class="pi pi-times" aria-hidden="true"></i>
  </button>
  <div [formGroup]="form1" class="forms w-100 d-block">
    <div class="row m-0">
      <div class="col-lg-12">
        @if (formAlert) {
          <div class="w-100 mb-3">
            <div class="w-100"  style="text-align: center;background-color: yellow;padding: 5px;margin-bottom: 15px;">
              <p><b>{{ formAlert }}</b></p>
            </div>
          </div>
        }
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="subjAdrStreet" id="subjAdrStreet" type="text" pInputText/>
          <label for="subjAdrStreet">Street Name</label>
          @for (validation of validationMessages.subjAdrStreet; track validation) {
            <span>
              @if (form1.get('subjAdrStreet').hasError(validation.type) && (form1.get('subjAdrStreet').dirty || form1.get('subjAdrStreet').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="subjAdrUnit" id="subjAdrUnit" type="text" pInputText/>
          <label for="subjAdrUnit">Address Unit</label>
          @for (validation of validationMessages.subjAdrUnit; track validation) {
            <span>
              @if (form1.get('subjAdrUnit').hasError(validation.type) && (form1.get('subjAdrUnit').dirty || form1.get('subjAdrUnit').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="subjAdrCity" id="subjAdrCity" type="text" pInputText/>
          <label for="subjAdrCity">City</label>
          @for (validation of validationMessages.subjAdrCity; track validation) {
            <span>
              @if (form1.get('subjAdrCity').hasError(validation.type) && (form1.get('subjAdrCity').dirty || form1.get('subjAdrCity').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="subjAdrState" id="subjAdrState" type="text" pInputText/>
          <label for="subjAdrState">State</label>
          @for (validation of validationMessages.subjAdrState; track validation) {
            <span>
              @if (form1.get('subjAdrState').hasError(validation.type) && (form1.get('subjAdrState').dirty || form1.get('subjAdrState').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="subjAdrPostalCode" id="subjAdrPostalCode" type="text" pInputText/>
          <label for="subjAdrPostalCode">Zip code</label>
          @for (validation of validationMessages.subjAdrPostalCode; track validation) {
            <span>
              @if (form1.get('subjAdrPostalCode').hasError(validation.type) && (form1.get('subjAdrPostalCode').dirty || form1.get('subjAdrPostalCode').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="row m-0">
        <div class="col-lg-12">
          <div class="btn-group">
            <div class="button-group">
              <button pButton class="btn-cancel p-button-text" [mat-dialog-close]="true">Close</button>
              <button pButton  class="btn-addt p-button" (click)="requestProforma()">Create</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
